import { render, staticRenderFns } from "./financeconfig.vue?vue&type=template&id=081f22a4&scoped=true&"
import script from "./financeconfig.vue?vue&type=script&lang=js&"
export * from "./financeconfig.vue?vue&type=script&lang=js&"
import style0 from "./financeconfig.vue?vue&type=style&index=0&id=081f22a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f22a4",
  null
  
)

export default component.exports